class Navigation {
  stateClasses = {
    open: "nav--open",
    noScroll: "no-scroll",
  }

  constructor($el) {
    this.$el = $el;
    this.$trigger = this.$el.find('[data-nav="trigger"]');
    this.$overlay = this.$el.find('[data-nav="overlay"]');
    this.$close = this.$el.find('[data-nav="close"]');
    this.$html = $('html');
    this.isOpen = false;
    this.init();
  }

  init = () => {
    this.$trigger.on('click', this.clickHandler);
    this.$close.on('click', this.close);
    this.$overlay.on('click', this.close);

    $(document).on('keydown', (event) => {
      if (event.key === 'Escape' && this.isOpen) {
        event.preventDefault();
        this.close();
      }
    });
  }

  clickHandler = () => {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open = () => {
    this.$html.addClass(this.stateClasses.open);
    this.$html.addClass(this.stateClasses.noScroll);
    this.isOpen = true;
  }

  close = () => {
    this.$html.removeClass(this.stateClasses.open);
    this.$html.removeClass(this.stateClasses.noScroll);
    this.isOpen = false;
  }
}

export default Navigation;